import { createContext } from 'react';

import { Period } from '../types';

type PeriodContext = {
  period: Period;
};

export const periodContext = createContext<PeriodContext>({ period: [] });
